import React from 'react';
import PropTypes from 'prop-types';
import { WarningCircle } from '@phosphor-icons/react';
import './style';

const Textarea = (props) => {
  const {
    value,
    disabled,
    contentLeft,
    iconLeft,
    label,
    labelIcon,
    onChange,
    width,
    validationStatus,
    helpText,
    className,
    charLength,
    required,
    ...attr
  } = props;

  const onInputChange = (e) => {
    if (e?.target?.value?.length <= charLength) onChange(e);
  };

  return (
    <div
      className={`textarea-container flex flex-col gap-2 ${className}`}
      {...(width && ({ style: { width } }))}
    >
      <label
        className={`label flex items-center gap-1.5 label-16 ${required ? 'required' : ''}`}
        htmlFor="textarea-field"
      >
        {label}
        {labelIcon}
      </label>
      <div className="textarea-field-wrapper shadow-xs flex relative">
        {contentLeft && (
          <div className="textarea-content-left flex items-center justify-center">
            <span className="content label-16 w-full px-6 py-2.5">{contentLeft}</span>
          </div>
        )}
        <textarea
          name="textarea-field"
          className={`textarea-field label-16 w-full py-3 px-5`
            + `${contentLeft ? ' content-left' : ''}`
            + `${validationStatus ? ` ${validationStatus} content-right` : ''}`
            + `${iconLeft ? ' icon-left' : ''}`
          }
          value={value}
          disabled={disabled}
          onChange={onInputChange}
          {...attr}
        />
        {iconLeft && (
          <div className="textarea-icon-left h-full flex items-center justify-center absolute">
            <span className="content">{iconLeft}</span>
          </div>
        )}
        {(validationStatus === 'error') && (
          <div className="textarea-content-right flex items-center justify-center absolute">
            <div className="content"><WarningCircle size={26}
              color="#D92D20"
              weight="fill" /></div>
          </div>
        )}
      </div>
      <div className="text-12 flex items-center justify-between">
        <div className={`help-text ${validationStatus === 'error' ? 'text-error' : 'text-grey-70'}`}>{helpText}</div>
        <div className="text-grey-70">{value?.length || 0} / {charLength}</div>
      </div>
    </div>
  );
};

Textarea.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  contentLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  iconLeft: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelIcon: PropTypes.element,
  onChange: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validationStatus: PropTypes.string,
  helpText: PropTypes.string,
  className: PropTypes.string,
  charLength: PropTypes.number,
};

Textarea.defaultProps = {
  value: null,
  disabled: false,
  contentLeft: null,
  iconLeft: null,
  label: null,
  labelIcon: null,
  onChange: () => null,
  width: 640,
  validationStatus: null,
  helpText: null,
  className: '',
  charLength: 100,
};

export default Textarea;
